
const maxId = Number.MAX_SAFE_INTEGER - 1;

// function to help create unique ids for html elements;
// this is kinda based off how angular cdk/material components work
export function generateHtmlId(prefix: string): () => string {
  let nextId = 0;
  return () => {
    nextId++;
    if (nextId > maxId) {
      nextId = 0;
    }

    return `${prefix}-${nextId}`;
  };
}
